/* ============================================================================
 * Project        : Deloitte Digital Compliance
 * File           : GrantAccessDrawer.jsx
 * Version        : 1.0.0
 * Author         : Team Neubinary
 * Created On     : 2026-06-24
 *
 * Description    : Digital Compliance for Automation and Governance
 *
 * Change History :
 * ----------------------------------------------------------------------------
 * Date         | Version | Author           | Description
 * ----------------------------------------------------------------------------
 * 2026-06-24   | 1.0.0   | Team Neubinary   | Initial creation
 * <YYYY-MM-DD> | x.x.x   | <Name/Team>      | <Change description>
 * ============================================================================
 *
 * Copyright (c) 2026 AU79 Consulting Services Pvt. Ltd.
 * All Rights Reserved.
 *
 * This source code and its contents are confidential and proprietary to
 * AU79 Consulting Services Pvt. Ltd. Unauthorized copying, reproduction,
 * modification, distribution, or disclosure of this material, in whole or
 * in part, is strictly prohibited without prior written permission from
 * AU79 Consulting Services Pvt. Ltd.
 * ============================================================================
 */
import {
  Drawer,
  Box,
  Typography,
  IconButton,
  Divider,
  MenuItem,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import CustomButtonV2 from "../../../../components/customComponentsV2/common/button/CustomButtonV2";
import userManagementApis from "../../../../redux/actions/userManagent";
import {
  HandleApiActions,
  showToastMessage,
} from "../../../../redux/actions/actionHandler";
import ConflictViewer from "./ConflictViewer";
import CustomSelectV2 from "../../../../components/customComponentsV2/common/select/CustomSelectV2";
import deleteIcon from "../../../../assets/delete_icon.png";
const PERMISSION_LEVELS = [
  { value: "OWNER", label: "Owner" },
  { value: "EDITOR", label: "Editor" },
  { value: "VIEWER", label: "Viewer" },
];

/* -------------------- Conflict Normalizer -------------------- */
function normalizeConflicts(apiResult, usersById) {
  const conflicts = [];

  /* 🔴 HARD ERRORS (NON-OVERRIDABLE) */
  (apiResult?.errors || []).forEach((e) => {
    conflicts.push({
      type: "ERROR",
      user_id: e.user_id,
      user_label: usersById[e.user_id] || e.user_id,
      reason: e.error,
      details: "This access cannot be granted",
      blocking: true,
    });
  });

  if (!apiResult?.warnings?.length) return conflicts;

  for (const w of apiResult.warnings) {
    const userLabel = usersById[w.user_id] || w.user_id;
    let added = false;

    (w.sameLevelAccess || []).forEach((c) => {
      added = true;
      conflicts.push({
        type: "DUPLICATE",
        user_id: w.user_id,
        user_label: userLabel,
        reason: "Access already exists at same level",
        details: `Existing permission: ${c.existing_permission} (${c.role})`,
        blocking: false,
      });
    });

    (w.inheritedAccess || []).forEach((c) => {
      added = true;
      conflicts.push({
        type: "INHERITED",
        user_id: w.user_id,
        user_label: userLabel,
        reason: `Inherited from ${c.inherited_from_scope}`,
        details: `Role: ${c.role}`,
        blocking: false,
      });
    });

    (w.policyConflicts || []).forEach((c) => {
      added = true;
      conflicts.push({
        type: "POLICY",
        user_id: w.user_id,
        user_label: userLabel,
        reason: "Policy conflict",
        details: `Action denied: ${c.action}`,
        blocking: true,
      });
    });

    if (!added) {
      conflicts.push({
        type: "CONFIRMATION",
        user_id: w.user_id,
        user_label: userLabel,
        reason: "Confirmation required",
        details: "User already has effective access",
        blocking: false,
      });
    }
  }

  return conflicts;
}

/* -------------------- Resource Resolver -------------------- */
function resolveResourceIds(context) {
  switch (context.access_type) {
    case "PROJECT":
      return [context.project_id];
    case "VARIANT":
      return [context.variant_id];
    case "EE":
      return [context.ee_id];
    case "SWM":
      return [context.swm_id];
    case "VS":
      return [context.vs_id];
    case "VC":
      return [context.vc_id];
    default:
      throw new Error("INVALID_SCOPE_CONTEXT");
  }
}

/* -------------------- Drawer -------------------- */
function GrantAccessDrawer({
  open,
  onClose,
  context,
  supplierNamesList,
  entityAllUsersList,
}) {
  const dispatch = useDispatch();

  const [users, setUsers] = useState([]);
  const [rows, setRows] = useState([]);
  const [submitting, setSubmitting] = useState(false);
  const [result, setResult] = useState(null);
  const [conflictView, setConflictView] = useState([]);
  const [filteredUsers, setFilteredUsers] = useState([]);
  const [availableUsers, setAvailableUsers] = useState();
  console.log("contextcontextcontextcontext", context);
  const resetAndClose = () => {
    setRows([]);
    setResult(null);
    setConflictView([]);
    setSubmitting(false);
    onClose();
  };

  /* Reset state on close */
  useEffect(() => {
    if (!open) {
      setRows([]);
      setResult(null);
      setConflictView([]);
    }
  }, [open]);

  // useEffect(() => {
  //   let newArray = [];
  //   console.log(
  //     "supplierNamesListsupplierNamesListsupplierNamesList",
  //     supplierNamesList,
  //   );
  //   console.log("UsersUsers", users);

  

  //   console.log("filteredSuppliers", filteredSuppliers);
  //   console.log(
  //     "filteredNotSuppliersTAReviewer",
  //     filteredNotSuppliersTAReviewer,
  //   );
  // }, [users]);
  // useEffect(() => {
  //   console.log("Usersusersusers", users);
  //   if (!users) return;

  

  

  //   setFilteredUsers(result);
  // }, [users, supplierNamesList]);
  useEffect(() => {
    console.log("supplierNamesList", supplierNamesList);
    console.log("Users", users);

    if (!users) return;

    const filteredSuppliers = users.filter(
      (data) => data?.role_details?.description === supplierNamesList?.[0],
    );

    const filteredNotSuppliersTAReviewer = users.filter(
      (data) =>
        data?.role_details?.capability_code?.toUpperCase() !==
        "EXTERNAL_SUPPLIER_USER",
    );

    const newAllUserArray = [
      ...filteredSuppliers,
      ...filteredNotSuppliersTAReviewer,
    ];

    console.log("filteredSuppliers", filteredSuppliers);
    console.log(
      "filteredNotSuppliersTAReviewer",
      filteredNotSuppliersTAReviewer,
    );

    // If you need to store it
    setFilteredUsers(newAllUserArray);
  }, [users, supplierNamesList]);

  useEffect(() => {
  // remove entityAllUsers from newAllUserArray
  let newUsers = filteredUsers.filter((au) =>
    !entityAllUsersList.some((eu) => eu.user_id === au.user_id)
  );
  setAvailableUsers(newUsers);
}, [rows, filteredUsers]);
  /* Load users */
  useEffect(() => {
    if (!open) return;

    dispatch(
      HandleApiActions({
        ...userManagementApis.get_users_list_pa,
        show_toast: false,
        params: { page_number: 1, page_size: 500 },
      }),
    ).then((resp) => {
      if (!resp?.error) setUsers(resp.data || []);
    });
  }, [open]);

  /* Build conflicts */
  useEffect(() => {
    if (!result) return;

    if (result.status === "WARNING" || result.status === "ERROR") {
      const usersById = Object.fromEntries(
        users.map((u) => [u.user_id, `${u.fullname} (${u.email})`]),
      );
      setConflictView(normalizeConflicts(result, usersById));
    } else {
      setConflictView([]);
    }
  }, [result]);

  console.log("resultresultresultresultresultresult", result);

  const addRow = () =>
    setRows((r) => [...r, { user_id: "", permission_level: "VIEWER" }]);
  const removeRow = (index) => {
    setRows((prevRows) => prevRows.filter((_, i) => i !== index));
  };
  const updateRow = (idx, key, value) =>
    setRows((r) =>
      r.map((row, i) => (i === idx ? { ...row, [key]: value } : row)),
    );

  const submit = async (confirm = false) => {
    setSubmitting(true);

    let resource_ids;
    try {
      resource_ids = resolveResourceIds(context);
    } catch {
      setSubmitting(false);
      return;
    }

    if (!resource_ids[0]) {
      showToastMessage({
        type: "error",
        message: "No valid resource selected",
      });
      setSubmitting(false);
      return;
    }

    const resp = await dispatch(
      HandleApiActions({
        ...userManagementApis.grant_project_access,
        show_toast: false,
        params: {
          scope: context.access_type,
          resource_ids,
          grants: rows,
          confirm,
        },
      }),
    );

    console.log("resprespresprespresp", resp);

    setSubmitting(false);
    setResult(resp || null);
  };

  const userDetailsAll = (user_id) => {
    let seletedUsers = users?.find((data) => data?.user_id === user_id);
    console.log(
      "seletedUsersseletedUsersseletedUsersseletedUsers",
      seletedUsers,
    );
    return seletedUsers?.fullname;
  };

  return (
    <Drawer open={open} anchor="right" PaperProps={{ sx: { width: 520 } }}>
      <Box
        sx={{ p: 2, display: "flex", flexDirection: "column", height: "100%" }}
      >
        {/* Header */}
        <Box sx={{ display: "flex", justifyContent: "space-between" }}>
          <Typography fontWeight={600}>Manage Access</Typography>
          <IconButton onClick={resetAndClose}>
            <CloseIcon />
          </IconButton>
        </Box>

        <Divider sx={{ my: 2 }} />

        {/* Grant Rows */}
        <Box sx={{ flexGrow: 1 }}>
          {rows.map((row, idx) => (
            <Box key={idx} sx={{ display: "flex", gap: 1, mb: 1 }}>
              {/* <Select
                fullWidth
                value={row.user_id}
                onChange={(e) => updateRow(idx, "user_id", e.target.value)}
              >
            

                {filteredUsers?.map((u) => (
                  <MenuItem key={u.user_id} value={u.user_id}>
                    {u.fullname} ({u.email})
                  </MenuItem>
                ))}
              </Select> */}
              <CustomSelectV2
                showLabel
                heightExpand={true}
                enableSearch={true}
                required
                label="User"
                optionsList={
                  availableUsers?.map((u) => ({
                    label: `${u.fullname} (${u.email})`,
                    value: u.user_id,
                  })) || []
                }
                selectedValue={row.user_id}
                handleOnChange={(e) =>
                  updateRow(idx, "user_id", e.target.value)
                }
              />

              {/* <Select
                value={row.permission_level}
                onChange={(e) =>
                  updateRow(idx, "permission_level", e.target.value)
                }
              >
                {PERMISSION_LEVELS.map((p) => (
                  <MenuItem key={p.value} value={p.value}>
                    {p.label}
                  </MenuItem>
                ))}
              </Select> */}
              <CustomSelectV2
                showLabel
                heightExpand={true}
                enableSearch={true}
                required
                label="Permission Level"
                optionsList={PERMISSION_LEVELS || []}
                selectedValue={row.permission_level}
                handleOnChange={(e) =>
                  updateRow(idx, "permission_level", e.target.value)
                }
              />

              <IconButton
                size="small"
                sx={{ p: 0, mt: 2 }}
                onClick={() => removeRow(idx)}
              >
                <img
                  src={deleteIcon}
                  alt="delete"
                  style={{ width: 24, height: 24 }}
                />
              </IconButton>
            </Box>
          ))}

          <CustomButtonV2
            btnName="Add User"
            size="small"
            handleOnClick={addRow}
          />
        </Box>

        {result?.status === "WARNING" && conflictView.length > 0 && (
          <ConflictViewer
            conflicts={conflictView}
            onConfirm={() => submit(true)}
            onCancel={() => {
              setConflictView([]);
              setResult(null);
            }}
          />
        )}

        {result?.status === "SUCCESS" && result.success?.length > 0 && (
          <Typography color="success.main">
            Access granted successfully
          </Typography>
        )}

        {result?.status === "ERROR" && (
          <Box sx={{ mt: 2 }}>
            <Typography color="error.main" fontWeight={600}>
              Access could not be granted
            </Typography>

            {result.errors.map((e, idx) => (
              <Typography key={idx} fontSize={13}>
                {userDetailsAll(e.user_id)}: {e.error}
              </Typography>
            ))}
          </Box>
        )}

        <Divider sx={{ my: 2 }} />

        {/* Footer */}
        <Box sx={{ display: "flex", justifyContent: "flex-end", gap: 1 }}>
          <CustomButtonV2 btnName="Cancel" handleOnClick={resetAndClose} />
          <CustomButtonV2
            btnName="Grant Access"
            disabled={!rows.length || submitting}
            handleOnClick={() => submit(false)}
          />
        </Box>
      </Box>
    </Drawer>
  );
}

export default GrantAccessDrawer;
